  document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('BrandSearchInput');
  const brandItems = document.querySelectorAll(
    '.image-grid-item-inner[data-brand]'
  );

  if (!searchInput || !brandItems.length) return;

  function filterBrands() {
    const searchTerm = searchInput.value
      .trim()
      .toLowerCase();

    brandItems.forEach(function (brand) {
      const brandName = brand.dataset.brand
        .trim()
        .toLowerCase();

      const brandItem = brand.closest('.image-grid-item');

      if (!brandItem) return;

      const isMatch =
        searchTerm === '' ||
        brandName.includes(searchTerm);

      brandItem.style.display = isMatch ? '' : 'none';
    });
  }

  searchInput.addEventListener('input', filterBrands);
});